var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-card-title", [
        _vm._v("Please provide any Additional Information/Questions below.")
      ]),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c("p", { staticClass: "text-subtitle-1" }, [
            _vm._v(
              "If you have an special equipment request, please add them in notes below. Please be\n            as\n            specific as possible, we will contact you if we have question."
            )
          ]),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: { max: 200, "auto-grow": "", outlined: "", rows: "4" },
            model: {
              value: _vm.reservation.additional_info,
              callback: function($$v) {
                _vm.$set(_vm.reservation, "additional_info", $$v)
              },
              expression: "reservation.additional_info"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }